import React from 'react';

const IDCardSVGOld = ({ className, parentClassName }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M25.2255 6.85608H6.58111C5.05223 6.85608 3.80957 8.10868 3.80957 9.64979V22.3481C3.80957 23.8892 5.05223 25.1418 6.58111 25.1418H25.2255C26.7544 25.1418 27.997 23.8892 27.997 22.3481V9.64979C27.997 8.10868 26.7544 6.85608 25.2255 6.85608ZM11.3681 10.9195C12.757 10.9195 13.8876 12.0594 13.8876 13.4593C13.8876 14.8591 12.757 15.9989 11.3681 15.9989C9.97933 15.9989 8.84868 14.8591 8.84868 13.4593C8.84868 12.0594 9.97933 10.9195 11.3681 10.9195ZM15.9033 20.3165C15.9033 20.737 15.5647 21.0784 15.1474 21.0784H7.58886C7.17162 21.0784 6.833 20.737 6.833 20.3165V19.8085C6.833 18.2674 8.07566 17.0147 9.60454 17.0147H13.1318C14.6606 17.0147 15.9033 18.2674 15.9033 19.8085V20.3165ZM24.2177 21.0784H18.6748C18.2576 21.0784 17.919 20.737 17.919 20.3165C17.919 19.8959 18.2576 19.5546 18.6748 19.5546H24.2177C24.635 19.5546 24.9736 19.8959 24.9736 20.3165C24.9736 20.737 24.635 21.0784 24.2177 21.0784ZM24.2177 17.0147H18.6748C18.2576 17.0147 17.919 16.6734 17.919 16.2528C17.919 15.8323 18.2576 15.4909 18.6748 15.4909H24.2177C24.635 15.4909 24.9736 15.8323 24.9736 16.2528C24.9736 16.6734 24.635 17.0147 24.2177 17.0147ZM24.2177 12.9513H18.6748C18.2576 12.9513 17.919 12.61 17.919 12.1894C17.919 11.7688 18.2576 11.4275 18.6748 11.4275H24.2177C24.635 11.4275 24.9736 11.7688 24.9736 12.1894C24.9736 12.61 24.635 12.9513 24.2177 12.9513Z"
      fill="none"
      className={className}
    />
  </svg>
);

const IDCardSVG = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 4.5C2.51625 4.5 1.5 5.51625 1.5 6.75V17.25C1.5 18.4838 2.51625 19.5 3.75 19.5H20.25C21.4838 19.5 22.5 18.4838 22.5 17.25V6.75C22.5 5.51625 21.4838 4.5 20.25 4.5H3.75ZM5.25 10.5C5.25 8.85 6.6 7.5 8.25 7.5C9.9 7.5 11.25 8.85 11.25 10.5C11.25 11.3355 10.8923 12.0877 10.3358 12.633C10.8463 12.9775 11.2648 13.4416 11.5549 13.9849C11.8449 14.5282 11.9977 15.1341 12 15.75H10.5C10.5 14.499 9.501 13.5 8.25 13.5C6.999 13.5 6 14.499 6 15.75H4.5C4.50226 15.1341 4.65508 14.5282 4.94515 13.9849C5.23522 13.4416 5.65374 12.9775 6.16425 12.633C5.60775 12.0877 5.25 11.3348 5.25 10.5ZM13.5 9.75V8.25H19.5V9.75H13.5ZM13.5 12.75V11.25H19.5V12.75H13.5ZM13.5 14.25V15.75H17.25V14.25H13.5Z"
      fill="none"
      className={className}
    />
    <path
      d="M9.75 10.5C9.75 9.66225 9.08775 9 8.25 9C7.41225 9 6.75 9.66225 6.75 10.5C6.75 11.3377 7.41225 12 8.25 12C9.08775 12 9.75 11.3377 9.75 10.5Z"
      fill="none"
      className={className}
    />
  </svg>
);

export { IDCardSVG };
